import useMediaQuery from '../../hooks/useMediaQuery.js';

export const useUI = () => {
  const esMobile = useMediaQuery('(max-width: 600px)');
  const esDesktop = useMediaQuery('(min-width: 1200px)');

  return {
    esMobile,
    esDesktop,
    EXPULSIONES_X_PAGINA: esMobile ? 20 : 30,
    GOLES_X_PAGINA: esMobile ? 20 : 30,
    PARTIDOS_X_PAGINA: !esDesktop ? 15 : 20,
    TORNEOS_X_PAGINA: 15,
    ITEM_COMBO_VACIO: '\u00A0',
  };
};
